import axiosRequest from "../universal/axiosService";
import { ENDPOINTS } from "../../apiConfig";

export const fetchClientSubmissionsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.BDMJOBS.GET_ALL,
    params: {
      ...params,
      fil: JSON.stringify(params.fil),
      sort: params.sort ? JSON.stringify(params.sort) : null,
    },
  });
};

export const fetchAllJobsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      // ret: "uiid jobInfo skills orgInform jobId status addedOn addedBy",
      ret: params.ret || null,
      // ref: "Job Note Submission",
      ref: params.ref || null,
      // incl: JSON.stringify(["companyId"]),
      extret: params.extret || null,
      fil: JSON.stringify(params.fil),
      incl: params.incl,
      sort: JSON.stringify(params.sort),
      useAggregate: params.useAggregate || false,
    },
  });
};

export const addNoteApi = async ({ coll = "Note", postActions, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.NOTES.ADD}`,
    data: {
      coll,
      postActions,
      payload,
    },
  });
};

export const fetchAllNotes = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.NOTES.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      ret: params.ret || null,
      fil: JSON.stringify(params.fil),
      extret: params.extret || null,
      sort: JSON.stringify({ addedOn: -1 }),
      slowConfig: {
      enabled: true,
      time: 5000,
      message: "Loading notes is taking longer than expected...",
    },
    },
  });
};

export const fetchAllSubmissions = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.BDMJOBS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      ref: params.ref || null,
      ret: params.ret || null,
      fil: JSON.stringify(params.fil),
      extret: params.extret || null,
      incl: params.incl,
      sort: JSON.stringify(params.sort),
      useAggregate: params.useAggregate || false,
    },
  });
};

export const fetchSimilarSubmissions = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate || true,
    },
  });
};

export const fetchProspectsByCompany = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.PROSPECTS.GET_ALL}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      ret: params.ret || null,
      lim: params.lim || null,
    },
  });
};

export const fetchJobPost = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET}`,
    params: {
      coll: params.coll,
      // ret: "uiid jobInfo skills orgInform jobId status addedOn addedBy",
      ret: params.ret || null,
      // ref: "Job Note Submission",
      ref: params.ref || null,
      // incl: JSON.stringify(["companyId"]),
      extret: params.extret || null,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      incl: params.incl,
      extincl: params.extincl,
    },
  });
};

export const fetchJobPostingSmartInsights = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      useAggregate: params.useAggregate ? params.useAggregate : true,
      queryMode: params?.queryMode ? params.queryMode : null,
    },
  });
};

export const fetchJobCardCounts = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const fetchJobQuestions = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      ret: params.ret || null,
      lim: params.lim || null,
      pg: params.pg || null,
      extret: params.extret,
      ref: params.ref,
    },
  });
};

export const updateJobPostStatus = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid and status are required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.JOBPOSTINGS.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const updateSubmissionStatus = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid and status are required");
  }
  console.log("coll, uiid,", coll, uiid);
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.SUBMISSOINS.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const updateTalentMatchStatus = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid and status are required");
  }
  console.log("coll, uiid,", coll, uiid);
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.TALENT_MATCH.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const MonsterClassicSearch = async (params) => {
  // console.log("api bdmjobs params",params)
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SEARCH.MONSTER_SEARCH,
    data: params,
  });
};

export const getMonsterResumeImport = async (params) => {
  // console.log("api bdmjobs params",params)
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SEARCH.MONSTER_RESUME_IMPORT,
    data: params,
  });
};

// export const fetchAllRecruiters = async (params) => {
//   return await axiosRequest({
//     method: "GET",
//     url: `${ENDPOINTS.RECRUITERS.GET_ALL}`,
//     params: {
//       coll: params.coll,
//       lim : params.lim || 10,
//       pg : params.pg || 1,
//       ret: params.ret || null,
//       fil : JSON.stringify(params.fil ?? {}),
//       extret : params.extret || null
//     },
//   });
// }

export const fetchJobBoardHistoryApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOB_BOARDS_HISTORY.HISTORY}`,
    params: {
      lim: params.lim || 10,
      pg: params.pg || 1,
      fil: JSON.stringify(params.fil || {}),
      addedOn: -1,
      addedBy: params.addedBy,
    },
  });
};

export const fetchConfirmedOrStartApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.SUBMISSOINS.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim || 10,
      pg: params?.pg || 1,
      ref: params.ref,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      incl: params.incl ? JSON.stringify(params.incl) : null,
      extret: params.extret || null,
      ret: params.ret || null,
      sort: JSON.stringify(params.sort),
    },
  });
};

export const fetchAllRecruitersApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USERS.GET_ALL}`,
    params: {
      coll: params.coll || "User",
      pg: params.pg || 1,
      lim: params.lim || 50,
      ret: params.ret || "uiid firstName lastName",
      fil: JSON.stringify({
        role: { type: "IN", value: [4] },
        organizationId: { type: "NONE", value: params.orgId },
      }),
    },
  });
};

export const fetchAllRecruitersAndBDMUsers = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USER_REFS.ATS_USER_GET_ALL}`,
    params: {
      pg: params.pg || 1,
      lim: params.lim || 50,
      ret: params.ret || "uiid firstName lastName",
      fil: JSON.stringify({
        "role.type": { type: "IN", value: [1, 3, 4] },
      }),
      // extret: params.extret || null
    },
  });
};

//Resume Mining
export const fetchResumeMining = async (params) => {
  console.log("API : ", params);
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.RESUME_MINING.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const addResumeMining = async ({ coll = "ResumeMining", payload }) => {
  console.log("Comming in api");
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.RESUME_MINING.ADD}`,
    data: {
      coll,
      payload,
    },
  });
};

export const updateResumeMining = async ({
  coll = "ResumeMining",
  uiid,
  payload,
}) => {
  if (!uiid) {
    throw new Error("uiid is required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.RESUME_MINING.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

// export const deleteResumeMining = async ({ coll = "ResumeMining", uiid }) => {
//   if (!uiid) {
//     throw new Error("uiid is required");
//   }

//   return await axiosRequest({
//     method: "DELETE",
//     url: `${ENDPOINTS.RESUME_MINING.DELETE}`,
//     data: {
//       coll: coll,
//       uiid: Number(uiid),
//     },
//   });
// };

export const careerBuilderSearch = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.SEARCH.CAREER_BUILDER_SEARCH}`,
    data: {
      ...payload,
    },
  });
};

export const fetchTalentMatch = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.TALENT_MATCH.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg || 1,
      lim: params.lim || 10,
      ref: params.ref || null,
      ret: params.ret || null,
      fil: JSON.stringify(params.fil),
      extret: params.extret || null,
      incl: params.incl,
      sort: JSON.stringify(params.sort),
    },
  });
};

export const fetchAddSubmissionData = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.SUBMISSOINS.POST}`,
    data: {
      coll: params.coll,
      postActions: params.postActions,
      payload: params.payload,
    },
  });
};

export const fetchResumeData = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.INTEGRATIONS.POST}`,
    body: {
      payload,
    },
  });
};

export const addCandidateNotes = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.NOTES.ADD}`,
    data: payload,
  });
};

export const addEmailPost = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.EMAIL.POST}`,
    data: payload,
  });
};

export const talentMatchCountPercentage = async (payload) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.TALENT_MATCH.GET_ALL}`,
    params: payload,
  });
};

export const saveRecentSearch = async (id, body) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.JOB_BOARDS_HISTORY.HISTORY}?id=${id}`,
    data: body,
  });
};

export const fetchNoActivityJobs = async (payload) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: payload,
  });
};

export const jobsTableFilter = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getMonsterResumesImport = async (params) => {
  // console.log("api bdmjobs params",params)
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SEARCH.MONSTER_RESUMES_IMPORT,
    data: params,
  });
};

export const getCareerBuilderResumesImport = async (params) => {
  // console.log("api bdmjobs params",params)
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SEARCH.CAREER_BUILDER_RESUMES_IMPORT,
    data: params,
  });
};

export const userRefCount = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USER_REFS.ATS_USER_COUNT}`,
    params: {
      ...params,
    },
  });
};

export const saveIntegratedRecentSearch = async (body) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.JOB_BOARDS_HISTORY.ADD}`,
    data: body,
  });
};

export const globalSearchApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.CANDIDATES.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const fetchSmartInsightsJobsData = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
    params: {
      coll: params.coll,
      fil: params.fil ? JSON.stringify(params.fil) : null,
      useAggregate: params.useAggregate ? params.useAggregate : true,
      lim: params?.lim,
      pg: params?.pg,
    },
  });
};

export const getLeadCompany = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.LEAD_COMPANY.GET_ALL}`,
    params: {
      coll: params.coll,
      lim: params?.lim,
      pg: params?.pg,
      sort: JSON.stringify(params?.sort),
      ret: params?.ret,
      ref: params?.ref,
      extret: params?.extret,
      fil: JSON.stringify(params?.fil),
    },
  });
};

export const addLeadCompany = async (body) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.LEAD_COMPANY.ADD}`,
    data: body,
  });
};

export const updateLeadCompany = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid are required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.LEAD_COMPANY.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const deleteCompany = async (payload) => {
  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.LEAD_COMPANY.DELETE,
    data: payload,
  });
}

export const getLeadCompanyByUiid = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.LEAD_COMPANY.GET}`,
    params: {
      coll: params.coll,
      ret: params?.ret,
      ref: params?.ref,
      extret: params?.extret,
      fil: JSON.stringify(params?.fil),
    },
  });
};

export const getLeadJobs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.LEAD_JOB.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const getLeadContacts = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.LEAD_CONTACT.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const addLeadJob = async (body) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.LEAD_JOB.ADD}`,
    data: body,
  });
};

export const updateLeadJob = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid are required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.LEAD_JOB.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const addLeadContact = async (body) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.LEAD_CONTACT.ADD}`,
    data: body,
  });
};

export const updateLeadContact = async ({ coll, uiid, payload }) => {
  if (!coll || !uiid) {
    throw new Error("coll, uiid are required");
  }

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.LEAD_CONTACT.UPDATE}?coll=${coll}&uiid=${uiid}`,
    data: {
      payload: payload,
    },
  });
};

export const updateAgreementLeadCompany = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.LEAD_COMPANY.UPDATE}?uploadType=multiple&field=file&coll=${params.coll}&uiid=${params.uiid}`,
    data: params.data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchAllBDMUsers = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.USER_REFS.ATS_USER_GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const fetchAllLeadJobs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.LEAD_JOB.GET_ALL}`,
    params: {
      ...params,
    },
  });
};

export const pushToWorkforceApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INCOMING_PLACEMENTS.PUSH,
    data: payload,
  });
};

export const pushDataToWorkforceBackendApi = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SUBMISSOINS.PUSH_TO_WORKFORCE,
    data,
  });
};
